<template>
    <div class="body">
        <MenuPage />
        <div class="content">
            <div class="content-cards container">
                <div class="row">
                    <div class="col-12 col-md-4 m-t-12">
                        <Card class="metric-card" @click="OpenUsuarios()">
                            <template #title>
                                <span class="metric-title" >Usuarios</span>
                            </template>
                            <template #content>
                                <h1 class="metric-value">{{ usuarios }}</h1>
                            </template>
                        </Card>
                    </div><br><br>
                    <div class="col-12 col-md-4 m-t-12">
                        <Card class="metric-card" @click="OpenClientes()">
                            <template #title>
                                <span class="metric-title">Clientes</span>
                            </template>
                            <template #content>
                                <h1 class="metric-value">{{ clientes }}</h1>
                            </template>
                        </Card>
                    </div><br><br>
                    <div class="col-12 col-md-4 m-t-12">
                        <Card class="metric-card" >
                            <template #title>
                                <span class="metric-title">Ordenes de Sericio</span>
                            </template>
                            <template #content>
                                <h1 class="metric-value">{{ ordenes }}</h1>
                            </template>
                        </Card>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import MenuPage from './MenuPage.vue';
import Card from 'primevue/card';
import api from '@/plugins/axios';
import { useRouter } from 'vue-router';


const clientes = ref(0);
const usuarios = ref(0);
const ordenes = ref(0);
const router = useRouter();

const getUser = async () => {
    try {
        const res = await api.get("/getnumber");
        usuarios.value = res.data;
    }
    catch (err) {
        console.error(err);
    }
}

const getClientes = async () => {
    try {
        const res = await api.get("/Cliente/getnumber");
        clientes.value = res.data;
    }
    catch (err) {
        console.error(err);
    }
}


const getOrders = async ()=>{
    try{
        const res = await api.get("/orden/getnumber");
        ordenes.value = res.data;
    }
    catch(err)
    {
        console.error(err);
    }
} 

const OpenClientes =()=>{
    router.push("AdminCliente");
}

const OpenUsuarios =()=>{
    router.push("AdminUsuario");
}

onMounted(() => {
    getUser();
    getClientes();
    getOrders();
});
</script>

<style scoped>
/* @media (max-width: 1200px) {
    .content
    {
        width: 75%;
        left: 7%;
    }
} */


.metric-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    padding: 25px;
    text-align: center;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    cursor: pointer;
}

.metric-card:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
}

.metric-title {
    font-size: 1rem;
    font-weight: 600;
    color: #6c757d;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 12px;
    display: block;
}

.metric-value {
    font-size: 2.8rem;
    font-weight: 700;
    color: #0d6efd;
    /* azul bootstrap moderno */
    margin: 0;
    line-height: 1.2;
}
</style>